import React from "react";
import Skeleton from "react-loading-skeleton";

const FieldSkeleton = ({ labelWidth = 140 }: { labelWidth?: number }) => (
  <div className="flex flex-col gap-[6px]">
    <Skeleton height={10} width={labelWidth} />
    <Skeleton height={42} borderRadius={8} />
  </div>
);

const ToggleRowSkeleton = () => (
  <div className="flex flex-row justify-between items-start gap-4">
    <div className="flex flex-col gap-[6px]">
      <Skeleton height={10} width={120} />
      <Skeleton height={10} width={220} />
    </div>
    <Skeleton height={16} width={32} borderRadius={999} />
  </div>
);

const SectionSkeleton = ({
  children,
  titleWidth,
}: {
  children: React.ReactNode;
  titleWidth: number;
}) => (
  <div className="flex flex-col">
    <Skeleton height={12} width={titleWidth} className="mb-[8px]" />
    <div className="flex flex-col border border-border-subtle bg-bg-page-body rounded-[8px] p-[12px] gap-[12px]">
      {children}
    </div>
  </div>
);

const PrimeIndiaVpnSettingsSkeleton = () => {
  return (
    <div className="flex flex-col gap-[16px] max-w-[820px]">
      <Skeleton height={10} width={220} />

      <SectionSkeleton titleWidth={150}>
        <ToggleRowSkeleton />
        <FieldSkeleton labelWidth={160} />
      </SectionSkeleton>

      <SectionSkeleton titleWidth={170}>
        <ToggleRowSkeleton />
        <FieldSkeleton labelWidth={200} />
      </SectionSkeleton>

      <SectionSkeleton titleWidth={140}>
        <FieldSkeleton labelWidth={150} />
      </SectionSkeleton>

      <SectionSkeleton titleWidth={170}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[12px]">
          <FieldSkeleton labelWidth={100} />
          <FieldSkeleton labelWidth={90} />
          <FieldSkeleton labelWidth={140} />
          <FieldSkeleton labelWidth={130} />
        </div>
      </SectionSkeleton>

      <SectionSkeleton titleWidth={150}>
        <FieldSkeleton labelWidth={130} />
        <FieldSkeleton labelWidth={110} />
      </SectionSkeleton>
    </div>
  );
};

export default PrimeIndiaVpnSettingsSkeleton;
